import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeStep: {index: 0, value: 'MC'},
  completedSteps: {},
  steps: []
};

export const stepperSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    setCompletedStep: (state, action) => {
      state.completedSteps[action.payload.stepIndex] = action.payload.completed;
    },
    setSteps: (state, action) => {
      state.steps = action.payload;
    },
    resetStepper: (state) => {
      return initialState;
    }
  }
});

export const { setActiveStep, setCompletedStep, setSteps, resetStepper } = stepperSlice.actions;

export const selectActiveStep = (state) => state.stepper.activeStep;
export const selectCompletedSteps = (state) => state.stepper.completedSteps;
export const selectSteps = (state) => state.stepper.steps;
export const selectStepper = (state) => state.stepper;

export const getActiveStep = (state) => state.stepper.activeStep;
export const getCompletedSteps = (state) => state.stepper.completedSteps;
export const getSteps = (state) => state.stepper.steps;


export default stepperSlice.reducer;
